import "./index.scss";
import { $, $all, forEach, on } from "@olmokit/dom";
import { post } from "@olmokit/core/fragments/ajax";
import { FormProductProps } from "components/Form/ProductDetail/Property";
import FormsSelectMaterial from "@olmokit/core/forms/select/material";

/**
 * Component: FormProductCart
 */
export function FormProductDetail() {
  console.log("FormProductDetail mounted.");

  // const $container = $all('.FormProductDetail:');
  // const $products = $all('.FormProductDetail:product', $container);
  // const property = $('.FormProductDetail:property');

  // forEach($container, (product, index) => {
  //   const $selectContainer = $('.FormProductId:'+index);
  //   const $select = $('select', $selectContainer);
  //   on($select, 'change', (event) => {
  //     makeThePost(index, event.target.value);
  //     FormsSelectMaterial();
  //     const $productInput = $('#of-9-products');
  //     let array = [];
  //     let obj = {
  //       product: event.target.value
  //     };
  //     array.push(obj);
  //     $productInput.value = JSON.stringify(array);
  //   });
  // });  

} 
